import {
  generateFilterForm,
  IListTimesheetFetchParams,
  ITimesheet,
  useListContext,
} from '@jobcost-monorepo/crud';
import { FiltersForm } from '@jobcost-monorepo/ui';
import React from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { ISearch } from '..';
import useJobOrdersFields from '../../hooks/useJobOrdersFields';

interface Props {
  isOpen: boolean;
  onSubmit: SubmitHandler<ISearch>;
  handleClose: () => void;
}

const FiltersTimesheet: React.FC<Props> = ({
  isOpen,
  onSubmit,
  handleClose,
}) => {
  const methods = useFormContext<ISearch>();
  const { repository } = useListContext<
    ITimesheet,
    IListTimesheetFetchParams
  >();

  const { getValues } = methods;

  const handleResetFilters = async () => {
    onSubmit({ ...getValues(), jobId: undefined, orderId: undefined });
    handleClose();
  };

  const handleFilter = async () => {
    const data = getValues();
    onSubmit(data);
    handleClose();
  };

  useJobOrdersFields();

  return (
    <FiltersForm
      isOpen={isOpen}
      handleClose={handleClose}
      handleResetFilters={handleResetFilters}
      handleFilter={handleFilter}
    >
      <div className="p-4">
        {generateFilterForm<ITimesheet, IListTimesheetFetchParams>(
          repository.gridFiltersOptions,
        )}
      </div>
    </FiltersForm>
  );
};

export default FiltersTimesheet;
